// All constants and static data for the ShopDetails feature
// See ARCHITECTURE_GUIDE.md for rules

export const SHOP_TYPE_CATEGORIES = [
  {
    label: '🔧 Service', items: [
      { label: 'Cleaning services', value: 'SV_cleaning' },
      { label: 'Repairs & maintenance', value: 'SV_repairs' },
      { label: 'Beauty salons / barbershops', value: 'SV_beauty' },
      { label: 'Freelance / consulting', value: 'SV_freelance' },
      { label: 'Printing / copy services', value: 'SV_printing' },
      { label: 'Events & photography', value: 'SV_events' }
    ]
  },
  {
    label: '🍽️ Food & Beverage', items: [
      { label: 'Restaurant / café', value: 'FB_restaurant' },
      { label: 'Bakery', value: 'FB_bakery' },
      { label: 'Catering', value: 'FB_catering' },
      { label: 'Food truck', value: 'FB_foodTruck' },
      { label: 'Bar / pub', value: 'FB_bar' }
    ]
  },
  {
    label: '🛍️ Retail', items: [
      { label: 'Clothing & apparel', value: 'RT_clothing' },
      { label: 'Electronics', value: 'RT_electronics' },
      { label: 'Grocery / convenience store', value: 'RT_grocery' },
      { label: 'Furniture / home goods', value: 'RT_furniture' },
      { label: 'Specialty shop (e.g., pet store, toy store)', value: 'RT_specialty' }
    ]
  },
  {
    label: '💻 Technology & Online', items: [
      { label: 'Web development', value: 'TO_webDev' },
      { label: 'SaaS / digital tools', value: 'TO_saas' },
      { label: 'E-commerce store', value: 'TO_ecommerce' },
      { label: 'IT services', value: 'TO_itServices' },
      { label: 'Mobile apps', value: 'TO_mobileApps' }
    ]
  },
  {
    label: '🏥 Health & Wellness', items: [
      { label: 'Clinics / medical services', value: 'HW_medical' },
      { label: 'Pharmacy', value: 'HW_pharmacy' },
      { label: 'Fitness centers / gyms', value: 'HW_fitness' },
      { label: 'Spas / massage therapy', value: 'HW_spa' },
      { label: 'Mental health / counseling', value: 'HW_mentalHealth' }
    ]
  },
  {
    label: '🏠 Real Estate & Housing', items: [
      { label: 'Property rentals', value: 'RE_rentals' },
      { label: 'Real estate agencies', value: 'RE_realEstate' },
      { label: 'Interior design', value: 'RE_interiorDesign' },
      { label: 'Home improvement', value: 'RE_homeImprovement' }
    ]
  },
  {
    label: '🚗 Transportation & Automotive', items: [
      { label: 'Auto repair / detailing', value: 'TA_autoRepair' },
      { label: 'Car rentals / taxi services', value: 'TA_carRental' },
      { label: 'Logistics & delivery', value: 'TA_logistics' },
      { label: 'Bike or scooter rentals', value: 'TA_bikeRental' }
    ]
  },
  {
    label: '🏫 Education & Training', items: [
      { label: 'Schools / tutoring centers', value: 'ED_schools' },
      { label: 'Online courses', value: 'ED_onlineCourses' },
      { label: 'Language schools', value: 'ED_languageSchools' },
      { label: 'Workshops / seminars', value: 'ED_workshops' }
    ]
  },
  {
    label: '🏢 Professional Services', items: [
      { label: 'Legal services', value: 'PS_legal' },
      { label: 'Accounting / bookkeeping', value: 'PS_accounting' },
      { label: 'Insurance', value: 'PS_insurance' },
      { label: 'Marketing / advertising', value: 'PS_marketing' },
      { label: 'Engineering', value: 'PS_engineering' },
      { label: 'Consulting', value: 'PS_consulting' },
      { label: 'HR / staffing', value: 'PS_hr' }
    ]
  },
  {
    label: '🎉 Entertainment & Leisure', items: [
      { label: 'Gaming', value: 'EL_gaming' },
      { label: 'Event venues', value: 'EL_eventVenues' },
      { label: 'Art / music / theater', value: 'EL_arts' },
      { label: 'Travel & tourism', value: 'EL_travel' }
    ]
  }
];
